import { useQuery } from "@tanstack/react-query"
import { backofficeGoalsQuery } from "modules/backoffice/lib/campaigns/backofficeGoalsQuery"

export function useBackofficeGoalsQuery(...args: Parameters<typeof backofficeGoalsQuery>) {
  return useQuery(backofficeGoalsQuery(...args))
}
